module.exports = __webpack_public_path__ + "img/timeline-graph.292bcb9f.svg";